import React from 'react';
import StageSummary from './StageSummary';
import { Statistics } from './Home';
import { CategoryLink } from './categoryLink';
import {
  StageStatisticsStatus,
  StatisticValue,
  studiesNoun,
} from './stageStatistics';

type TitleAndAbstractProps = {
  reviewerName: string;
  irrelevant: number;
  stats: Statistics;
  status: StageStatisticsStatus;
  isOpen: boolean;
};

const TitleAndAbstract = ({
  irrelevant,
  reviewerName,
  stats,
  status,
  isOpen,
}: TitleAndAbstractProps) => {
  const secondaryContent = `${irrelevant} irrelevant`;
  const studyCategoryCount = (
    <>
      <StatisticValue status={status.counters} value={stats?.available} />{' '}
      {studiesNoun(status.counters, stats?.available)} to screen
    </>
  );
  return (
    <StageSummary
      isOpen={isOpen}
      stage="screen"
      title="Title and abstract screening"
      secondaryLink={CategoryLink('irrelevant')}
      secondaryContent={secondaryContent}
      studyCategoryCount={studyCategoryCount}
      studyCategoryLink={CategoryLink('screen')}
      reviewerName={reviewerName}
      stats={stats}
      status={status}
    />
  );
};

export default TitleAndAbstract;
